// extracted by mini-css-extract-plugin
module.exports = {"products":"_2wyo7sSSJAuQ3rRyCkEnyS","menuProductCol":"_3nCmeAWoWvYvYTOTwkHzUb"};